import React, { Component } from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import BalanceListContainer from '../../containers/balance/BalanceListContainer';
import { BALANCE_PAGE_NAME } from '../../constants/service/app/balanceConstants';

class BalanceWaitingList extends Component {
  render() {
    return (
      <PageTemplate pageName={BALANCE_PAGE_NAME.BALANCE_WAITING_LIST}>
        <BalanceListContainer pageType="ready" />
      </PageTemplate>
    );
  }
}

export default BalanceWaitingList;
